export class User {
  constructor(device) {
    this.device = device
  }
}



// WEBPACK FOOTER //
// ./src/api/model/StatisticsData/User.js